import { $api } from "../services/api";

const state = {
  myTaskList: [], //完成的任务id数组
  completeList: [], //我的完成的任务数组
};
const getters = {};
const actions = {
  /**
   * 完成任务
   * @param rootState 全局store
   * @param desc 任务描述
   * @param objectId 触发任务的对象id
   * @returns {*}
   */
  onCompleteTask(
    { rootState, state, dispatch },
    { desc, objectId, allLog = false }
  ) {
    if (!rootState.userInfo.token.smarketToken) return Promise.resolve();
    //判断是否完成过
    const findItem = state.completeList.find(
      (taskInfo) => taskInfo.explanation === desc || taskInfo.name == desc
    );

    const taskId = findItem && findItem.id;
    if (!taskId) return Promise.resolve();
    if (!allLog) {
      if (state.myTaskList.includes(taskId)) return Promise.resolve();
    }
    return $api
      .logAdd({
        taskId,
        objectId,
      })
      .then((data) => {
        if (state.myTaskList.includes(taskId)) return Promise.resolve();

        return $api
          .onInteractionTaskComplete({
            taskId,
            objectId,
            batchId: data.data.batchId,
          })
          .then(() => {
            return dispatch("onGetCompleteTaskList");
          });
      });
  },
  /**
   * 获取我完成的任务
   * @returns {*}
   */
  onGetCompleteTaskList({ rootState, commit }) {
    if (!rootState.userInfo.token.smarketToken) return Promise.resolve();
    return $api
      .onInteractionMyTaskComplete()
      .then((res) => {
        let completeList = [];
        const list = res.data || [];
        list.forEach((item) => {
          item.condition = item.condition || 1;
          if (item.completeNum >= 1) {
            completeList.push(item.id);
          }
        });
        commit("UPDATEMYCOMPLETETASKLIST", list);
        commit("UPDATEMYCOMPLETETASK", completeList);
        return Promise.resolve(res.data);
      })
      .catch((error) => {
        return Promise.resolve([]);
      });
  },
};
const mutations = {
  UPDATEMYCOMPLETETASK(state, myTaskList) {
    state.myTaskList = myTaskList;
  },
  UPDATEMYCOMPLETETASKLIST(state, completeList) {
    state.completeList = completeList;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
